import { render } from "./OrderFavorite.vue?vue&type=template&id=17cd981a"
import script from "./OrderFavorite.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFavorite.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderFavorite/OrderFavorite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17cd981a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17cd981a', __exports__)) {
    console.log('reload')
    api.reload('17cd981a', __exports__)
  }
  
  module.hot.accept("./OrderFavorite.vue?vue&type=template&id=17cd981a", () => {
    console.log('re-render')
    api.rerender('17cd981a', render)
  })

}


export default __exports__